import DisplayObject = PIXI.DisplayObject;

export enum Direction {
    Left = 'Left',
    Right = 'Right',
    Up = 'Up',
    Down = 'Down',
}

export function animateScale(object: DisplayObject, targetScale: number = 1.4): void {
    TweenLite.killTweensOf(object.scale);

    const originalScale: number = object.scale.x;
    const finalScale: number = object.scale.x * targetScale;

    TweenMax.to(object.scale, 0.3, {
        x: finalScale,
        y: finalScale,
        yoyo: true,
        repeat: 1,
        ease: Back.easeIn
    });
}

export function clearAnimations(object: DisplayObject): void {
    TweenLite.killTweensOf(object.scale);
    TweenLite.killTweensOf(object);
}

export function animateIdle(object: DisplayObject, targetScale: number = 1.1, repeat: number = -1): void {
    TweenLite.killTweensOf(object.scale);

    const originalScale: number = object.scale.x;
    const finalScale: number = object.scale.x * 1.03;
    const initialScale: number = object.scale.x * targetScale;

    TweenMax.to(object.scale, 0.1, {
        x: initialScale,
        y: initialScale,
        onComplete: (): void => {
            TweenMax.to(object.scale, 1.5, {
                x: finalScale,
                y: finalScale,
                yoyo: true,
                repeat: repeat,
                ease: Elastic.easeOut,
                onComplete: (): void => {
                    if (object && object.scale) {
                        clearAnimations(object);
                        TweenLite.to(object.scale, 0.1, {
                            x: originalScale,
                            y: originalScale
                        });
                    }
                }
            });
        }
    });
    // object.scale.set(initialScale, initialScale);
}

export function animatePopIn(
    object: DisplayObject,
    initialScale: number = 3,
    duration: number = 0.8,
    callback?: () => any,
    ease: Ease = Elastic.easeOut
): void {
    clearAnimations(object);
    const originalScaleX: number = object.scale.x + 0;
    const originalScaleY: number = object.scale.y + 0;
    object.scale.set(originalScaleX * initialScale, originalScaleY * initialScale);
    object.visible = true;
    TweenLite.to(object.scale, duration, {
        x: originalScaleX,
        y: originalScaleY,
        ease: ease,
        onComplete: (): void => {
            if (callback) {
                callback();
            }
        }
    });
}

export function animateMessage(
    object: DisplayObject,
    initialScale: number = 1.5,
    finalScaleMultiplier: number = 1,
    duration: number = 0.4,
    callback?: () => any,
    ease: Ease = Back.easeInOut
): void {
    clearAnimations(object);
    const originalScaleX: number = object.scale.x + 0;
    const originalScaleY: number = object.scale.y + 0;
    object.scale.set(originalScaleX * initialScale, originalScaleY * initialScale);
    object.alpha = 0;
    object.visible = true;
    TweenLite.to(object.scale, duration, {
        x: originalScaleX * finalScaleMultiplier,
        y: originalScaleY * finalScaleMultiplier,
        ease: ease,
        onComplete: (): void => {
            if (callback) {
                callback();
            }
            TweenLite.to(object, 0.4, {
                delay: 0.1,
                alpha: 0,
                onComplete: (): void => {
                    object.destroy();
                }
            });
        }
    });
    TweenLite.to(object, duration, {
        alpha: 1
    });
}

export function animateTileTutorial(object: DisplayObject, direction: Direction): void {
    let finalX: number = object.x;
    let finalY: number = object.y;
    switch (direction) {
        case Direction.Up: {
            finalY = object.y - 8;
            break;
        }
        case Direction.Down: {
            finalY = object.y + 8;
            break;
        }
        case Direction.Left: {
            finalX = object.x - 8;
            break;
        }
        case Direction.Right: {
            finalX = object.x - 8;
            break;
        }
    }
    TweenMax.from(object, 0.8, {
        x: finalX,
        y: finalY,
        yoyo: true,
        repeat: -1,
        ease: Elastic.easeOut,
    });
}